<ac-form *ngIf="dialogConfig.ready"
         [formSettings]="formSettings"
         [formSchema]="{}"
         [requiredsAuxiliaryForm]="entitySelectionObject.serviceType === 'VOCA' ?
         ['entitySelectionObject.entity.id', 'entitySelectionObject.subRegion.value'] : ['entitySelectionObject.entity.id']"
         [formModel]="entitySelectionObject"
         [auxiliaryModel]="entitySelectionObject"
         formModelName="entitySelectionObject">
    <ac-input-container [label]="entitySelectionObject.selectLabel" formFieldName="entitySelectionObject.entity.id">
        <ac-single-select [sortItems]="true"
                          [selectFirstAfterSort]="false"
                          [overrideSystemViewMode]="true"
                          bindLabel="name"
                          bindValue="id"
                          [items]="items"
                          [acModel]="entitySelectionObject.entity.id"
                          (acModelChange)="entitySelectionObject.entity.id = $event;entityChanged()">
        </ac-single-select>
    </ac-input-container>

    <ng-container *ngIf="entitySelectionObject?.serviceType === 'VOCA' && entitySelectionObject?.subRegion?.value">
        <ac-input-container label="Select Sub Region" formFieldName="entitySelectionObject.subRegion.value">
            <ac-single-select [(acModel)]="entitySelectionObject.subRegion.value"
                              [items]="subRegionalVocaList"
                              bindLabel="name"
                              bindValue="id">
            </ac-single-select>
        </ac-input-container>
    </ng-container>
</ac-form>


